/**
 * @generated SignedSource<<55926134e2684c5f9e7e9a0526026d18>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetListType = "COMMODITY" | "CRYPTOCOIN" | "EQUITY_SECURITY" | "INDEX" | "SECURITY";
export type AssetsGroupKey = "CRYPTO" | "ETC" | "ETF" | "INDEX" | "METAL" | "STOCK";
export type AssetsListGroup = "COIN" | "EQUITY_COMPLEX_ETC" | "EQUITY_COMPLEX_ETF" | "EQUITY_ETC" | "EQUITY_ETF" | "EQUITY_STOCK" | "ETC" | "ETF" | "INDEX" | "METAL" | "SECURITY_TOKEN" | "STOCK" | "TOKEN";
export type AssetsListSortBy = "MARKETCAP" | "NAME" | "PRICE" | "PRICE_CHANGE_1MONTH" | "PRICE_CHANGE_1WEEK" | "PRICE_CHANGE_1YEAR" | "PRICE_CHANGE_24HOURS";
export type SortOrder = "ASC" | "DESC";
export type AssetsListInput = {
  after?: string | null | undefined;
  allowBuy?: boolean | null | undefined;
  before?: string | null | undefined;
  first?: number | null | undefined;
  group?: AssetsListGroup | null | undefined;
  groups?: ReadonlyArray<AssetsListGroup> | null | undefined;
  last?: number | null | undefined;
  searchTerm?: string | null | undefined;
  sortBy?: AssetsListSortBy | null | undefined;
  sortOrder?: SortOrder | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
  type?: AssetListType | null | undefined;
  types?: ReadonlyArray<AssetListType> | null | undefined;
};
export type GetPaginatedAssetsForSearchAndSelectQuery$variables = {
  input?: AssetsListInput | null | undefined;
};
export type GetPaginatedAssetsForSearchAndSelectQuery$data = {
  readonly assetGroups: ReadonlyArray<{
    readonly __typename: "AssetGroup";
    readonly key: AssetsGroupKey;
    readonly value: ReadonlyArray<AssetsListGroup>;
  }>;
  readonly assets: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly logoUrl: string | null | undefined;
        readonly name: string | null | undefined;
        readonly price: PrecisionFloat | null | undefined;
        readonly symbol: string | null | undefined;
      };
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    } | null | undefined;
    readonly totalCount: number | null | undefined;
  } | null | undefined;
};
export type GetPaginatedAssetsForSearchAndSelectQuery = {
  response: GetPaginatedAssetsForSearchAndSelectQuery$data;
  variables: GetPaginatedAssetsForSearchAndSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetGroup",
  "kind": "LinkedField",
  "name": "assetGroups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetPaginatedAssetsForSearchAndSelectQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AssetsConnection",
        "kind": "LinkedField",
        "name": "assets",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetPaginatedAssetsForSearchAndSelectQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AssetsConnection",
        "kind": "LinkedField",
        "name": "assets",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6616ac3d639816bcda46d680adf87d6a",
    "id": null,
    "metadata": {},
    "name": "GetPaginatedAssetsForSearchAndSelectQuery",
    "operationKind": "query",
    "text": "query GetPaginatedAssetsForSearchAndSelectQuery(\n  $input: AssetsListInput\n) {\n  assetGroups {\n    key\n    value\n    __typename\n  }\n  assets(input: $input) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      startCursor\n      hasPreviousPage\n    }\n    totalCount\n    edges {\n      node {\n        __typename\n        id\n        symbol\n        logoUrl\n        name\n        price\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5c340b6ad7fe5e743d20eaa6cd0bc86";

export default node;
